import { render, staticRenderFns } from "./ListStage.vue?vue&type=template&id=65f0c526"
import script from "./ListStage.vue?vue&type=script&lang=js"
export * from "./ListStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListStage.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f0c526')) {
      api.createRecord('65f0c526', component.options)
    } else {
      api.reload('65f0c526', component.options)
    }
    module.hot.accept("./ListStage.vue?vue&type=template&id=65f0c526", function () {
      api.rerender('65f0c526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/views/ListStage.vue"
export default component.exports